import WeatherHealthBadge from "./WeatherHealthBadge";

const STATUS_LABELS = {
  active: "Active",
  acknowledged: "Acknowledged",
  resolved: "Resolved",
  muted: "Muted",
};

function formatWhen(value) {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleString();
}

const WeatherMonitoringAlertTable = ({
  alerts = [],
  loading = false,
  canManage = false,
  onAcknowledge,
  onResolve,
  onMute,
}) => {
  if (loading) {
    return <p className="admin-muted">Loading alerts…</p>;
  }

  if (!alerts.length) {
    return (
      <AdminEmptyState message="No operational alerts match the current filters." />
    );
  }

  return (
    <div className="admin-table-wrap">
      <table className="admin-table admin-table--compact">
        <thead>
          <tr>
            <th>Severity</th>
            <th>Status</th>
            <th>Source</th>
            <th>Type</th>
            <th>Title</th>
            <th>First detected</th>
            <th>Last detected</th>
            <th>Count</th>
            <th>Message</th>
            {canManage ? <th>Actions</th> : null}
          </tr>
        </thead>
        <tbody>
          {alerts.map((alert) => (
            <tr key={alert.alertId}>
              <td>
                <WeatherHealthBadge status={alert.severity} label={alert.severity} />
              </td>
              <td>{STATUS_LABELS[alert.status] || alert.status}</td>
              <td>{alert.sourceKey || "—"}</td>
              <td>
                <code className="admin-code">{alert.alertType}</code>
              </td>
              <td>{alert.title}</td>
              <td>{formatWhen(alert.firstDetectedAt)}</td>
              <td>{formatWhen(alert.lastDetectedAt)}</td>
              <td>{alert.occurrenceCount ?? 1}</td>
              <td className="admin-table__message-cell">{alert.message}</td>
              {canManage ? (
                <td className="admin-table__actions">
                  {alert.status === "active" ? (
                    <>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm"
                        onClick={() => onAcknowledge?.(alert)}
                      >
                        Acknowledge
                      </button>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm"
                        onClick={() => onResolve?.(alert)}
                      >
                        Resolve
                      </button>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm admin-btn--ghost"
                        onClick={() => onMute?.(alert)}
                      >
                        Mute
                      </button>
                    </>
                  ) : null}
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

function AdminEmptyState({ message }) {
  return <p className="admin-muted admin-empty-state">{message}</p>;
}

export default WeatherMonitoringAlertTable;
